import React, { Component } from 'react';
import { Grid, } from '@material-ui/core';
import { Doughnut, Bar } from 'react-chartjs-2';
import { withStyles } from '@material-ui/styles';
import useStyles from './styles';
import { createRefetchContainer, graphql, requestSubscription } from 'react-relay';
import environment from '../../environment';
var moment = require('moment-timezone');

class WMRightSectionResult extends Component {
    constructor(props){
        super(props);
        this.state = {
            current_bid: 5,
            current_pool: 0,
            current_group_number: 1,
            last_group: {},
            next_groups: [],
        }
    }

    componentDidMount(){
        const { getLonewolfPersonalData, quarter_id, chapters, guest_token, event_id } = this.props;
        if(getLonewolfPersonalData.getLonewolfPersonalData){
            const data = getLonewolfPersonalData.getLonewolfPersonalData.data;
            let total_labels = [];
            let total_datasets = [];
            let total_graph_data = {};
            let user_datasets = [];

            // For Total Graph
            if(quarter_id == -1){
                let quarter = 1;
                let group_number = 1;
                let temp = 0;
                let user_temp = 0;

                data.winnings_by_group.forEach((group, i) => {
                    if(group.group_number < group_number){
                        let current_chapter = chapters.filter(ch => ch.quarter_number == quarter)[0];
                        let chapter_name = current_chapter ? current_chapter.quarter_name : '';
                        total_labels.push(chapter_name);
                        total_datasets.push(temp);
                        user_datasets.push(user_temp);
                        quarter += 1;
                        group_number = 1;
                        temp = 0;
                        user_temp = 0;
                    } else {
                        group_number = group.group_number;
                        if(group.money){
                            temp += parseInt(group.money);
                            if(group.user_won) user_temp += parseInt(group.money);
                        }
                    }
                    if(i == data.winnings_by_group.length - 1){
                        let current_chapter = chapters.filter(ch => ch.quarter_number == quarter)[0];
                        let chapter_name = current_chapter ? current_chapter.quarter_name : '';
                        total_labels.push(chapter_name);
                        total_datasets.push(temp);
                        user_datasets.push(user_temp);
                    }
                });
                while(quarter < chapters.length){
                    const ch = chapters[quarter];
                    if(ch.quarter_number != -1){
                        total_labels.push(ch.quarter_name);
                        total_datasets.push(0);
                        user_datasets.push(0);
                    }
                    quarter += 1;
                }

                let dataArray = [{
                    data: total_datasets,
                    backgroundColor: 'rgb(255,255,255)',
                }];
                if(guest_token) dataArray.unshift({
                    data: user_datasets,
                    backgroundColor: 'rgb(190,214,0)',
                });

                total_graph_data = {
                    labels: total_labels,
                    datasets: dataArray,
                };
            }

            this.setState({
                current_bid: data.current_bid,
                current_pool: data.current_pool,
                current_group_number: data.current_group_number,
                last_group: data.last_group,
                next_groups: data.next_groups && data.next_groups.length > 2 ? data.next_groups.slice(0, 2) : data.next_groups,
                total_graph_data: total_graph_data,
            });
        }

        const subscriptionConfig = {
            subscription: graphql`
                subscription WMRightSectionResultSubscription($event_id: ID!, $quarter_id: ID!){
                    golfLeaderboardFindEventById(event_id: $event_id, quarter_id: $quarter_id){
                        event_id
                        quarter_id
                    }
                }
            `,
            variables: { event_id: event_id, quarter_id: quarter_id },
            onError: error => console.log("Subscription error : ", error),
            updater: store => {
                this.props.refetchData();
            },
        };
        this.subscription = requestSubscription(environment, subscriptionConfig);
    }

    componentDidUpdate(prevProps){
        if(prevProps.quarter_id != this.props.quarter_id) this._refetch();
    }

    componentWillUnmount(){
        this.subscription.dispose();
    }

    render(){
        const { classes, quarter_id, chapters } = this.props;
        const { current_bid, current_group_number, current_pool, last_group, next_groups, total_graph_data, total_datasets } = this.state;
        let winning_players_text = [];
        if(last_group && last_group.winning_players) last_group.winning_players.forEach(pl => {
            const split_name = pl.split(" ");
            winning_players_text.push(`${split_name[0][0]}. ${split_name[1]}`);
        });

        if(quarter_id == -1){ // Total Leaderboard Segment
            return (
                <Grid container justifyContent='center' style={{height: '90vh'}}>
                    <div style={{width: '90%', height: '80vh', marginTop: '1em',}}>
                        <Bar
                            data={total_graph_data}
                            options={{
                                responsive: true,
                                maintainAspectRatio: false,
                                legend: {
                                    display: false
                                },
                                scales: {
                                    xAxes: [{
                                        stacked: true,
                                        ticks: {
                                            fontColor: 'white',
                                            fontSize: 18,
                                            fontFamily: 'Maax-Bold',
                                        },
                                        gridLines: {
                                            color: 'rgba(0, 0, 0, 0)',
                                            zeroLineColor: 'transparent',
                                            zeroLineWidth: 0,
                                        },
                                        gridLines: {
                                            color: 'rgba(0, 0, 0, 0)',
                                            zeroLineColor: 'white',
                                            zeroLineWidth: 3,
                                        },
                                    }],
                                    yAxes: [{
                                        stacked: false,
                                        scaleLabel:{
                                            display: false,
                                        },
                                        ticks: {
                                            display: false,
                                        },
                                        gridLines: {
                                            display: false,
                                        },
                                    }]
                                },
                            }}
                        />
                    </div>
                </Grid>
            )
        } else return (
            <Grid container justifyContent='center' style={{height: '90vh'}}>
            {
                current_group_number ?
                !next_groups.length && !last_group.guests ?
                <Grid item xs={12} className={classes.rightGrid} style={{marginTop: '5em'}}>
                    <p className={classes.noticeText}>Check Back Later</p>
                </Grid>
                :
                <>
                <Grid item xs={12} className={classes.rightGrid}>
                    <p className={classes.largeTitle}>CURRENT POOL</p>
                    <hr className={classes.wmHR2} />
                    <p className={classes.extralargeText}>${current_pool ? current_pool.toLocaleString() : 0}</p>
                </Grid>
                <Grid item xs={6} className={classes.rightGrid} style={{marginTop: '-1em'}}>
                    <p className={classes.smallTitle}>CURRENT GROUP</p>
                    <hr className={classes.wmHR2} />
                    <p className={classes.largeText}>{current_group_number}</p>
                </Grid>
                <Grid item xs={6} className={classes.rightGrid} style={{marginTop: '-1em'}}>
                    <p className={classes.smallTitle}>CURRENT BID</p>
                    <hr className={classes.wmHR2} />
                    <p className={classes.largeText}>${current_bid}</p>
                </Grid>
                </>
                :
                <Grid item xs={12} className={classes.rightGrid} style={{marginTop: '5em'}}>
                    <p className={classes.noticeText}>Thanks For Playing!</p>
                </Grid>
            }
                <Grid item xs={12} style={{marginTop: '-1em'}}>
                    <p className={classes.largeTitle}>LAST GROUP</p>
                    <hr className={classes.wmHR2} style={{marginBottom: '1em'}} />
                    <div className={classes.lastgroupDiv}>
                        <div className={classes.leftDiv}>
                            <div>
                                <p className={classes.groupTitle}>GROUP {last_group.group_number ? last_group.group_number : '-'}</p>
                                <p className={classes.groupText}>{winning_players_text.join(",")}</p>
                                <p className={classes.groupText}>${last_group.winning_money ? `${Math.floor(last_group.winning_money)}/ea` : 'N/A'}</p>
                            </div>
                        </div>
                        <div className={classes.rightDiv}>
                            <div>
                            {
                                last_group.guests && last_group.guests.map((guest, i) => {
                                    return (
                                        <span key={`guest-${i}`}>{guest}</span>
                                    )
                                })
                            }
                            </div>
                        </div>
                    </div>
                </Grid>
            {
                next_groups.map((next, i) => {
                    let numbers = [];
                    let labels = [];
                    next.players.forEach(p => {
                        numbers.push(p.percentage);
                        labels.push(p.name);
                    });
                    const colors = [
                        'rgba(236, 170, 31, 1)',
                        'rgba(190, 214, 0, 1)',
                        'rgba(255, 255, 255, 1)'
                    ];
                    const graph_data = {
                        labels: labels,
                        datasets: [{
                            data: numbers,
                            backgroundColor: colors,
                            borderColor: colors,
                            options: {
                                plugins: {
                                    legend: {
                                        labels: {
                                            position: 'bottom',
                                        }
                                    }
                                }
                            }
                        }]
                    }
                    return (
                        <Grid item xs={6} className={classes.rightGrid} key={`nextgroup-${i}`}>
                            <p className={classes.smallTitle}>GROUP {next.group_number}</p>
                            <hr className={classes.wmHR2} style={{marginBottom: '1em'}} />
                            <Doughnut data={graph_data} height={80} options={{legend: false}} />
                            <div>
                            {
                                labels.map((label, j) => {
                                    const names = label.split(" ");
                                    const first = names[0];
                                    const last = names[1];
                                    return ([
                                        <div className={classes.chartLegend} style={{background: colors[j]}} key={`legend-${i}${j}`} />,
                                        <span className={classes.legendText} key={`legendText-${i}${j}`}>
                                            {`${first[0]}.${last}`}
                                        </span>
                                    ])
                                })
                            }
                            </div>
                        </Grid>
                    )
                })
            }
            </Grid>
        )
    }
}

export default createRefetchContainer(
    withStyles(useStyles)(WMRightSectionResult),
    {
        getLonewolfPersonalData: graphql`
            fragment WMRightSectionResult_getLonewolfPersonalData on Query
                @argumentDefinitions(
                    event_token: { type: "String!" }
                    guest_token: { type: "String!" }
                    quarter_id: { type: "Int!" }
                ){
                    getLonewolfPersonalData(event_token: $event_token, guest_token: $guest_token, quarter_id: $quarter_id){
                        data {
                            user {
                                name
                                points
                                position
                            }
                            current_group_number
                            current_bid
                            current_pool
                            last_group {
                                group_number
                                guests
                                winning_players
                                winning_money
                            }
                            winnings_by_group {
                                group_number
                                money
                                user_won
                            }
                            next_groups {
                                group_number
                                players {
                                    name
                                    percentage
                                    picked
                                }
                            }
                            total_page
                            cumulative_total_page
                        }
                    }
                }
        `
    },
    graphql`
        query WMRightSectionResultRefetchQuery($event_token: String!, $guest_token: String!, $quarter_id: Int!){
            ...WMRightSectionResult_getLonewolfPersonalData @arguments(event_token: $event_token, guest_token: $guest_token, quarter_id: $quarter_id)
        }
    `
);